import { render, staticRenderFns } from "./DynamicInboundCalls.vue?vue&type=template&id=7b35e9f0"
import script from "./DynamicInboundCalls.vue?vue&type=script&lang=js"
export * from "./DynamicInboundCalls.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports